import React, { useCallback, useState } from "react";
import { translate } from "../../../i18n";

import { useDispatch } from "react-redux";
import styled from "styled-components";
import { InviteMenuButton } from "../../../../options";
import { toggleParticipantRight } from "../../../../participant-right";
import { IconButton } from "../../../buttons";
import RightHeader from "../../../right-menu/RightHeader";
import ParticipantContent from "./ParticipantContent";

function ParticipantStatusContainer({
    t, open, handlerOpen
}) {
    const dispatch = useDispatch();
    const [search, setSearch] = useState(false);
    const [text, setText] = useState(null);

    const onSwitchSearh = useCallback(() => setSearch(!search), [search]);

    const handlerSearchText = e => {
        const text = e.target.value;
        
        setText(text);
    };

    const handlerClose = () => {
        dispatch(toggleParticipantRight(false));
    }

    return (
        <ParticipantStyled>
            <RightHeader name="participant" open={open} handlerOpen={handlerOpen} handlerClose={handlerClose}>
                { open && APP.layout.participant.invite && <InviteMenuButton /> }
                {/* { APP.layout.participant.allPermission && isShowRemote && <DevicePermissionRightMenutButton />  } */}
                { open && APP.layout.participant.search && <IconButton clsName={`button button_${search ? 'on': 'off'}`}
                    mode="search" size={14} onClick={onSwitchSearh} /> }
            </RightHeader>
            { open && <>
                { search && <div className="search_bar">
                    <input type="text" placeholder={ t("conference.inputParticipant") } onChange={handlerSearchText} />
                </div> }

                <ParticipantContent text={text} />
            </>}
        </ParticipantStyled>
    )
}

const ParticipantStyled = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .search_bar {
        height: 30px; width: 100%; background: #123; color: white; 

        input {
            border: none; background: none; color: #fff;
            width: 100%; height: 100%;
            box-sizing: border-box;
            padding: 0 12px;
        }
    }
`;

export default translate(ParticipantStatusContainer);